const getAcId= ()=>{
    return "LIVEAPP"
}
const getUnionId=async ()=>{
    if(localStorage.getItem("unionId")){
        return localStorage.getItem("unionId")
    }else{
        const unionId=`live_${Math.random().toString(36).substring(3, 13)}_${new Date().getTime()}`
        localStorage.setItem("unionId",unionId);
        return unionId;
    }
}
const PostLog = (data) => {
  const body = `
  {"__logs__":${JSON.stringify([data])}}`;
  fetch(
    `https://cjs-service-${
      process.env.PREACT_APP_ENV === "development" ? "test" : "prod"
    }.cn-shenzhen.log.aliyuncs.com/logstores/cjs-client-info/track`,
    {
      method: "POST",
      headers: {
        "x-log-apiversion": "0.6.0",
        "x-log-bodyrawsize": body.length,
      },
      body,
    }
  );
};

const UM = async (params) => {
  const unionId = await getUnionId();
  const searchParams=new URLSearchParams(window.location.search);
  const data = {
    da_id: `${unionId}`,
    gh_id: `${searchParams.get('gh_id')||""}`,
    sys: "liveapp",
    time: `${new Date().valueOf()}`,
    event: `click`,
    content: JSON.stringify(params),
  };
  PostLog(data);
};
export default UM;